module.exports = __webpack_public_path__ + "media/src/img/payment/elsom-b345bc5045ab38eb6cf4cc0a8e8b0663.svg";